import { Box, Button, Layer, Text } from "grommet";
import React from "react";
import { useStore } from "../../../../../Hooks/useStore";
import AtentionIcon from "../../../../../assets/Attention.svg";

function ErrorDialog() {
  const { rootStore } = useStore();
  const errorMessage = rootStore.errorHandlingStore.getErrorMessage;

  // Extract more detailed error information from the message
  const extractDetails = (msg: string): string => {
    if (msg.includes("403")) return "You don't have permission to access this resource.";
    if (msg.includes("400")) return "User account already exists.";
    if (msg.includes("User account already exist.")) return msg; // Show full Cognito message  
    return msg; // Default case
};

  const detailedMessage = extractDetails(errorMessage);

  return (
    <Layer
      onEsc={() => rootStore.errorHandlingStore.handleShowError(false)}
      onClickOutside={() => rootStore.errorHandlingStore.handleShowError(false)}
      style={{ 
        display: "inline-flex",
        padding: "40px 60px",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
        borderRadius: "12px",
        background: "var(--White, #FFF)",
        maxWidth: "500px"
      }}
    >
      <Box style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px"
      }}>
        <img style={{ width: "50px", height: "50px" }} src={AtentionIcon} alt="Error" />
        <Text style={{
          color: "#4B628A",
          textAlign: "center",
          fontFamily: "Inter",
          fontSize: "20px", 
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "28px"
        }}><b>ERROR</b></Text>
      </Box>

      <Text style={{
        color: "#4B628A",
        textAlign: "center",
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "22px",
        whiteSpace: "pre-line" // Preserves line breaks
      }}>
        {detailedMessage}
      </Text>

      <Button 
        style={{
          display: "flex",
          width: "140px",
          padding: "14px 49px",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          borderRadius: "10px",
          background: "#357EFF",
          color: "var(--all-colors-white-color-white, #FFF)",
          fontFamily: "Inter",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "24px"
        }} 
        label="Close" 
        onClick={() => rootStore.errorHandlingStore.handleShowError(false)} 
      />
    </Layer>
  );
}

export default ErrorDialog;